import React, { Fragment, useEffect, useMemo, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { toggleBillingPaymentDialog } from "../../../../actions/billingDialogs"
import {
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  useTheme,
  CircularProgress,
  TextField,
} from "@material-ui/core"
import formatNumberWithCommas from "../../../../utils/formatNumberWithCommas"
import logo from "../../../../assets/images/crewmama_logo_plain.svg"

import useStyles from "./styles"
import PaymentMethod from "./PaymentMethod/index"
import ChangePaymentText from "./ChangePaymentText/index"
import WaitingForPayment from "./WaitingForPayment/index"
import { Elements } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js"
import CheckoutForm from "./CheckoutForm/index"
import { createClientInvoice } from "../../../../actions/payments"
import { openSnackBar } from "../../../../actions/snack-bar"
import GreenButton from "../../Common/GreenButton/index"
import { markPaymentReceived } from "../../../../actions/billing"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import Checkbox from "@material-ui/core/Checkbox"
import { recallInvoiceForClient } from "../../../../actions/billing-crew-client"

// Had to move this out of the functional component because it was erring
// const stripeKey = process.env.REACT_APP_STRIPE_TEST
// const stripeKey =
//   process.env.REACT_APP_ENV === "production"
//     ? process.env.REACT_APP_STRIPE_LIVE
//     : process.env.REACT_APP_ENV === "staging"
//       ? process.env.REACT_APP_STRIPE_TEST
//       : process.env.REACT_APP_STRIPE_TEST
// const stripePromise = loadStripe(stripeKey)
//read read.me to see more documentation about payments
const BillingPaymentDialog = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const theme = useTheme()

  const [method, setMethod] = useState("")
  const [email, setEmail] = useState("")
  const [emailError, setEmailError] = useState(null)

  const [totalPayment, setTotalPayment] = useState(0)
  const [netBalance, setNetBalance] = useState(0)

  const [creditAmount, setCreditAmount] = useState(0)

  const [showAdditionalPayment, setShowAdditionalPayment] = useState(false)

  const open = useSelector(
    state => state.billingDialogs.billingPaymentDialogOpen
  )

  // const stripeKey =
  //   process.env.REACT_APP_ENV === "production"
  //     ? process.env.REACT_APP_STRIPE_LIVE
  //     : process.env.REACT_APP_ENV === "staging"
  //       ? process.env.REACT_APP_STRIPE_TEST
  //       : process.env.REACT_APP_STRIPE_TEST

  // const [stripePromise, setStripePromise] = useState(() => loadStripe(stripeKey))

  const data = useSelector(state => state.billingDialogs.data)
  const headerLogo = (data && data.headerLogo) || logo
  const final = (data && data.final) || false // final if (1) solo invoice payment or (2) invoice payment on a shoot
  const amountDue = (data && data.amountDue) || 0
  const totalAmount = (data && data.totalAmount) || 0
  const generalData = data && data.generalData
  const setGeneralData = data && data.setGeneralData
  const type = (data && data.type) || "shoot"
  const [loading, setLoading] = useState(false)
  const [options, setOptions] = useState()
  const buttonRef = useRef()
  //console.log("generalData2", generalData)
  const checkPaymentAllowed = useMemo(
    () => {
      if (data && data.generalData) {
        return data.generalData.client_check_payment
      } else {
        return null
      }
    },
    [data]
  )
  let stripeKey = process.env.REACT_APP_STRIPE_LIVE
  const checkAndSetStripeKey = () => {
    //debugger
    if (generalData && generalData.crewmama_or_gtt !== undefined) {
      stripeKey =
        generalData.crewmama_or_gtt !== "adwa"
          ? process.env.REACT_APP_STRIPE_LIVE
          : "pk_live_51OtD8CBDuXPEeVZlacnS8nPPxmtUOZlbOzsW0Vg8pp3xCkWAt8tkf1bHtihE6BSemfZLyb7UzVyxyqyQACa0Kgdi00j5UpyvJ5"
      //"pk_test_51OtD8CBDuXPEeVZlGGy3QQCkdpWblTuOd73InlmSNPqmV4Z6hT7aKgaZEPhAvGoVks4DLm1G1Z3rwRFfixx6hd3500kVncdRJw"
      //console.log(stripeKey)
      //return stripeKey
    } else {
      setTimeout(checkAndSetStripeKey, 100) // Check again after 100ms
    }
  }

  checkAndSetStripeKey() // Start the initial check
  //console.log("stripeKey", stripeKey)
  // Need to make condition below to decide which stripe key to use
  // const stripeKey =
  //   generalData.crewmama_or_gtt !== "adwa"
  //     ? "pk_live_ePZL8ZYpTh9lmXVWdJGGWq9h00Dy6CzZUL"
  //     : "pk_test_51OtD8CBDuXPEeVZlGGy3QQCkdpWblTuOd73InlmSNPqmV4Z6hT7aKgaZEPhAvGoVks4DLm1G1Z3rwRFfixx6hd3500kVncdRJw"
  // "pk_live_51OtD8CBDuXPEeVZlacnS8nPPxmtUOZlbOzsW0Vg8pp3xCkWAt8tkf1bHtihE6BSemfZLyb7UzVyxyqyQACa0Kgdi00j5UpyvJ5"
  const stripePromise = loadStripe(stripeKey)

  const paymentType = useMemo(
    () => {
      if (generalData && !data.final) {
        return generalData.first_payment_type
      } else if (generalData && data.final && generalData.deposit_required) {
        return generalData.second_payment_type
      } else if (generalData && data.final && !generalData.deposit_required) {
        return generalData.first_payment_type
      } else {
        return null
      }
    },
    [generalData]
  )

  // set initial payment method on pageload
  useEffect(
    () => {
      setMethod(data && paymentType)
    },
    [paymentType]
  )

  useEffect(
    () => {
      setNetBalance(amountDue)
      setTotalPayment(amountDue)
    },
    [amountDue]
  )

  useEffect(
    () => {
      if (totalPayment === 0) {
        setNetBalance(amountDue)
      }

      if (totalPayment > 0) {
        let addedValue = Number(amountDue) - Number(totalPayment)
        if (addedValue <= 0) {
          setCreditAmount(Math.abs(addedValue))
          setNetBalance(0)
        } else if (addedValue > 0) {
          setNetBalance(addedValue)
          setCreditAmount(0)
        }
      }
    },
    [totalPayment]
  )

  const showHelpText = useMemo(
    () => {
      if (generalData) {
        return paymentType !== "card"
      }
    },
    [paymentType]
  )

  const fees = useMemo(
    () => {
      if (method === "ach") {
        if (Number((amountDue * 0.8) / 100) >= 5) {
          return formatNumberWithCommas(5)
        } else {
          return formatNumberWithCommas((amountDue * 0.8) / 100)
        }
      } else if (method === "card") {
        return formatNumberWithCommas((amountDue * 3.8) / 100)
      }
    },
    [amountDue, method]
  )

  const payButtonText = useMemo(
    () => {
      let total = Number(amountDue) + Number(fees)
      if ((total && method === "card") || (total && method === "ach")) {
        return `Pay ($ ${formatNumberWithCommas(total)})`
      } else {
        return "Submit Payment"
      }
    },
    [method, fees]
  )
  //data to send to the api to update the payments method
  const callData = useMemo(
    () => {
      let data
      if (generalData) {
        if (generalData && !final) {
          data = {
            crewmama_or_gtt: generalData.crewmama_or_gtt,
            company_id: generalData.client_company_id,
            shoot_id: generalData.shoot_id,
            first_half_amount:
              method === "check"
                ? Number(totalPayment).toFixed(2)
                : amountDue.toFixed(2),
            client_id: generalData.company_user_id,
            first_payment_type: method,
            add_amount: creditAmount,
            shoot_name: generalData.shoot_name,
            representative: generalData.representative_name
              ? generalData.representative_name
              : generalData.creator_name,
            organization:
              generalData.company_id === 2
                ? generalData.crewmama_or_gtt
                : generalData.company_name,
          }
        } else if (generalData.deposit_required) {
          data = {
            crewmama_or_gtt: generalData.crewmama_or_gtt,
            second_payment_type: method,
            company_id: generalData.client_company_id,
            client_id: generalData.company_user_id,
            second_half_amount:
              method === "check"
                ? (Number(totalPayment) - Number(creditAmount)).toFixed(2)
                : amountDue.toFixed(2),
            add_amount: creditAmount,
            shoot_id: generalData.shoot_id,
            shoot_name: generalData.shoot_name,
            representative: generalData.representative_name
              ? generalData.representative_name
              : generalData.creator_name,
            organization:
              generalData.company_id === 2
                ? generalData.crewmama_or_gtt
                : generalData.company_name,
          }
        } else {
          data = {
            crewmama_or_gtt: generalData.crewmama_or_gtt,
            first_payment_type: method,
            company_id: generalData.client_company_id,
            client_id: generalData.company_user_id || generalData.client_id,
            full_amount:
              method === "check"
                ? (Number(totalPayment) - Number(creditAmount)).toFixed(2)
                : amountDue.toFixed(2),
            [`${
              type === "invoice" ? "solo_invoice" : "shoot"
            }_id`]: generalData[`${type}_id`],
            shoot_name: generalData.shoot_name,
            add_amount: creditAmount,
            representative: generalData.representative_name
              ? generalData.representative_name
              : generalData.creator_name,
            organization:
              generalData.company_id === 2
                ? generalData.crewmama_or_gtt
                : generalData.company_name,
          }
        }
        if (generalData.client_invoice_id !== null) {
          data = {
            ...data,
            regenerate: true,
            invoice_id: generalData.client_invoice_id,
          }
        }
        if (method === "ach") {
          data = {
            ...data,
            email: email,
          }
        }
        return data
      } else {
        return {}
      }
    },
    [generalData, method, email, amountDue, fees, creditAmount, netBalance]
  )

  const paidColumn = useMemo(
    () => {
      if (generalData && !final) {
        return "first_paid"
      } else if (generalData && generalData.deposit_required) {
        return "second_paid"
      } else if (generalData && !generalData.deposit_requied) {
        return "full_paid"
      }
    },
    [generalData]
  )

  const handleClose = () => {
    setTimeout(() => {
      setMethod("")
    }, 200)
    dispatch(toggleBillingPaymentDialog(false))
  }
  //starts the client invoice proccess, creating a row in client invoice table in db
  const createClientInvoiceCall = () => {
    //debugger
    dispatch(createClientInvoice(callData))
      .then(res => {
        if (method === "card") {
          setOptions({
            clientSecret: res.clientSecret,
          })
          sessionStorage.setItem("clientSecret", res.clientSecret)
          //to update the data that is in redux for this dialog
          if (generalData && !final) {
            callData.first_half_amount = amountDue
          } else if (generalData.deposit_required) {
            callData.second_half_amount = amountDue
          } else {
            callData.full_amount = amountDue
          }
          let newDialogData = {
            ...data,
            generalData: {
              ...generalData,
              ...callData,
              client_invoice_id: res.invoice_id,
            },
          }

          dispatch(toggleBillingPaymentDialog(true, newDialogData))
          dispatch(recallInvoiceForClient(true))

          setTimeout(() => {
            dispatch(recallInvoiceForClient(false))
            setLoading(false)
            handleClose()
          }, 60000)
        } else {
          dispatch(
            openSnackBar({
              message:
                method === "ach"
                  ? "Payment instructions sent"
                  : "Payment completed, pending receipt",
            })
          )

          dispatch(recallInvoiceForClient(true))

          setTimeout(() => {
            dispatch(recallInvoiceForClient(false))
            setLoading(false)
            handleClose()
          }, 300)
        }

        // setGeneralData(oldState => {
        //   return {
        //     ...oldState,
        //     ...callData,
        //     client_invoice_id: res.invoice_id,
        //   }
        // })
      })
      .catch(err => {
        console.log(err)
        setLoading(false)
        if (method !== "card") {
          dispatch(openSnackBar({ message: "Error submitting payment" }))
        }
      })
  }
  //if the client selects card we need the client secret key that comes from stripe
  //to render the element
  useEffect(
    () => {
      let clientSecretInLocalStorage = sessionStorage.getItem("clientSecret")
      if (clientSecretInLocalStorage && !options) {
        setOptions({ clientSecret: clientSecretInLocalStorage })
      } else if (open && method === "card") {
        createClientInvoiceCall()
      }
      // else if (open && method === "card" && !options) {
      //   createClientInvoiceCall()
      // }
    },

    [open, method]
  )

  const executePayFunction = () => {
    // debugger;
    setLoading(true)
    if (method === "card") {
      //call that comes from a child component (CheckoutForm)
      buttonRef.current
        .handleSubmit()
        .then(() => {
          let updateData = {
            paidColumn: paidColumn,
            paymentStatus: 1,
          }
          let invoiceId = generalData.client_invoice_id
          //mark as paid in db
          dispatch(markPaymentReceived(updateData, invoiceId))
            .then(() => {
              setGeneralData(oldState => {
                return {
                  ...oldState,
                  [paidColumn]: 1,
                }
              })
              // ALL OF THIS IS WHAT HAPPENS RIGHT AFTER THE PAYMENT IS SUBMITTED
              setLoading(false)
              dispatch(openSnackBar({ message: "Payment submitted" }))
              handleClose()
            })
            .catch(err => {
              console.log(err)
              setLoading(false)
              dispatch(openSnackBar({ message: "Error submitting payment" }))
            })
          //clear local sessions where we storage the client secret to render stripe element
          sessionStorage.clear()
        })
        .catch(err => {
          console.log(err)
          setLoading(false)
          dispatch(openSnackBar({ message: "Error submitting payment" }))
          //clear local sessions where we storage the client secret to render stripe element
          //in case that we have an old client secret
          sessionStorage.clear()
        })
    } else if (method === "check" || method === "ach") {
      //will be paid when the check or ach is received
      setLoading(true)
      createClientInvoiceCall()
    }
  }

  const handleChangeMethod = e => {
    setMethod(e.target.value)
  }

  // format validation & error handling specifically for email
  const isEmailValid = () => {
    const regex = /[\w\d.-]+@[\w\d.-]+\.[\w\d.-]+/
    if (!email || regex.test(email) === false) {
      setEmailError(`Not a valid email address`)
    } else {
      setEmailError(null)
    }
  }

  const handelTotalPayment = e => {
    let value = e.target.value
    let regix = /^[+-]?\d+(\.\d+)?$/
    if (value.match(regix) && value >= 0) {
      if (value[0] === "0") {
        value = value.substring(1)
      }

      setTotalPayment(value)
    }
    if (value === "") {
      setTotalPayment(0)
    }
  }

  const disabledBtn =
    !method ||
    totalPayment == "0" ||
    (method === "card" && !options) ||
    (method === "ach" && (!email || emailError))
  // (paymentType === "check") ||
  // (paymentType === "ach" && (method === "ach" || method == "check")) ||
  // (paymentType === "check" && (method === "ach" || method == "card"))

  return (
    <Dialog open={open} classes={{ paper: classes.dialogContainer }}>
      <DialogTitle className={classes.title}>
        <img
          src={headerLogo}
          alt="organization-logo"
          style={{ maxHeight: "100px" }}
        />
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Box mt={2} mb={2}>
          <Typography variant="h3">
            {final ? "Full Payment" : "Partial Payment"}
          </Typography>
          <Typography variant="subtitle1" style={{ marginTop: "8px" }}>
            {final
              ? "Please pay your final payment to Crew Mama"
              : "50% partial payment is required to move forward with your shoot. Please submit your payment below:"}
          </Typography>
        </Box>
        <Box mt={4} mb={4}>
          {!final && (
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="h2">Total Estimate</Typography>
              <Typography variant="h2">
                ${amountDue && formatNumberWithCommas(totalAmount)}
              </Typography>
            </Box>
          )}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            color={theme.palette.success.main}
            mt={2}
            mb={2}
          >
            <Typography variant="h2">
              {final ? "Balance:" : "Payment Due Today (50%):"}
            </Typography>
            <Typography variant="h2">
              ${amountDue && formatNumberWithCommas(amountDue)}
            </Typography>
          </Box>
          {method === "card" && (
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mt={2}
              mb={2}
            >
              <Typography>Transaction Fees (3.8%)</Typography>
              <Typography>${amountDue && fees}</Typography>
            </Box>
          )}
          {method === "ach" && (
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mt={2}
              mb={2}
            >
              <Typography>Transaction Fees (0.8% or $5 max.)</Typography>
              <Typography>${amountDue && fees}</Typography>
            </Box>
          )}
        </Box>
        <Box>
          {showHelpText && (
            <Fragment>
              <WaitingForPayment paymentType={paymentType} />
              <ChangePaymentText />
            </Fragment>
          )}
          <PaymentMethod
            method={method}
            handleChange={handleChangeMethod}
            checkPaymentAllowed={checkPaymentAllowed}
          />
          {method === "card" &&
            options &&
            options.clientSecret && (
              <Elements stripe={stripePromise} options={options}>
                <CheckoutForm buttonRef={buttonRef} setLoading={setLoading} />
              </Elements>
            )}
          {method === "ach" && (
            <TextField
              id="email"
              name="email"
              variant="outlined"
              label="Email"
              value={email}
              fullWidth
              onChange={e => setEmail(e.target.value)}
              onBlur={isEmailValid}
              style={{ flexGrow: 1 }}
              helperText={emailError}
              error={Boolean(emailError)}
            />
          )}

          {/* {method === "check" && final && (
            <FormControlLabel
              control={<Checkbox checked={showAdditionalPayment} onChange={handelCheckBox} />}
              label="Additional Payment"
            />
          )} */}

          {method === "check" &&
            final &&
            !showAdditionalPayment && (
              <TextField
                id="totalPayment"
                name="totalPayment"
                variant="outlined"
                label="Payment Amount"
                type="number"
                value={totalPayment}
                onChange={handelTotalPayment}
                fullWidth
                style={{ flexGrow: 1, marginTop: "30px" }}
              />
            )}

          {method === "check" &&
            final &&
            !showAdditionalPayment && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                color={theme.palette.success.main}
                mt={2}
                mb={2}
              >
                <Typography variant="h2">Remaning Balance:</Typography>
                <Typography variant="h2">
                  {/* {amountDue} {"- "}
                {totalPayment} {"  "} ={"  "} */}
                  $ {netBalance}
                </Typography>
              </Box>
            )}

          {method === "check" &&
            final &&
            creditAmount > 0 && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                color={theme.palette.success.main}
                mt={2}
                mb={2}
              >
                <Typography variant="h2">Credit:</Typography>
                <Typography variant="h2">
                  ${" "}
                  {Number(creditAmount) % 1 === 0
                    ? creditAmount
                    : creditAmount.toFixed(2)}
                </Typography>
              </Box>
            )}
        </Box>
      </DialogContent>
      <DialogActions style={{ justifyContent: "center" }}>
        <Box className={classes.buttons}>
          <GreenButton
            variant="contained"
            fullWidth
            onClick={executePayFunction}
            disabled={disabledBtn || loading}
          >
            {loading ? (
              <CircularProgress size={24} style={{ color: "#fff" }} />
            ) : (
              payButtonText
            )}
          </GreenButton>
          <Button
            variant="text"
            onClick={handleClose}
            fullWidth
            style={{ marginTop: "15px" }}
          >
            Cancel
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

export default BillingPaymentDialog
